// Strings for the read-only Careview tab, copied from client.ClientDetail.CareviewSettings.
export default {
  Title: 'Careview',
  Types: {
    FiveStar: {
      Title: 'Five star',
      Question: 'Question',
    },
    FreeFormText: {
      Title: 'Free form question',
      Question: 'Question',
      RequiredTitle: 'Required field?',
      Enabled: 'Yes',
      Disabled: 'No',
    },
    YesNo: {
      Title: 'Yes/No',
      Question: 'Question',
      FollowupEnabledYes: `Will trigger follow-up on 'Yes' response`,
      FollowupEnabledNo: `Will trigger follow-up on 'No' response`,
      Enabled: 'Enabled',
      Disabled: 'Disabled',
    },
    MultipleChoice: {
      Title: 'Multiple choice',
      Question: 'Question',
      Options: 'Options',
      FollowupEnable: `(Will trigger follow-up on response)`,
    },
  },
};
